import React, { useState } from 'react';
import {
  FormControl,
  Grid,
  InputLabel,
  Typography,
  MenuItem,
  Select,
  TextField,
  Box,
  ThemeProvider,
  createTheme,
  CssBaseline,
  Paper
} from '@mui/material';

import comoserproveedor from '../../recursos/comoserproveedor.jpg'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import PersonaNatural from '../Formularios/personaNatural';
import PersonaJuridica from '../Formularios/personaJuridica';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { encrypt, decrypt, getIDWorkmanagerRegistroProveedores } from '../FunctionLogin'
import { Business, Person, Work, LocationOn, AttachMoney, AssignmentInd } from '@mui/icons-material';

// --- Premium Theme Definition ---
const theme = createTheme({
  palette: {
    primary: {
      main: '#BD1F34', // Talsa Red
      dark: '#8a1525',
      light: '#e04f5f',
    },
    text: {
      primary: '#2D3436',
      secondary: '#636E72',
    },
    background: {
      default: '#F0F2F5',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Outfit", "Roboto", "Helvetica", "Arial", sans-serif',
    h5: {
      fontWeight: 700,
      color: '#BD1F34',
    },
    h6: {
      fontWeight: 600,
      color: '#2D3436',
    }
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
          overflow: 'hidden'
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '50px',
          textTransform: 'none',
          fontWeight: 600,
          boxShadow: '0 4px 14px 0 rgba(189, 31, 52, 0.39)',
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#F9FAFB',
            '&:hover fieldset': { borderColor: '#BD1F34' },
            '&.Mui-focused fieldset': { borderColor: '#BD1F34' },
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          backgroundColor: '#F9FAFB',
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#BD1F34' },
        }
      }
    }
  },
});

export default function FormularioRegistros() {

  const [nitRegistro, setNitRegistro] = useState('');
  const navigate = useNavigate();
  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const codigo = urlParams.get('id');
    const encodedValue = urlParams.get('id');
    if (encodedValue) {
      decrypt(decodeURIComponent(encodedValue)).then((result) => {
        if (result === "") {
          navigate("/proveedores/cerrar")
        }
        setNitRegistro(result)
        getIDWorkmanagerRegistroProveedores(result).then((resultv2) => {
          if (resultv2.length >= 1) {
            navigate("/proveedores/cerrar")
          }
        })
      });
    }
    if (codigo === null) {
      navigate("/proveedores/cerrar")
    }
  }, [])


  const sucursales = [
    "ANTIOQUIA",
    "CENTRO",
    "COSTA",
    "CÚCUTA",
    "EJE CAFETERO",
    "OCCIDENTE",
    "SANTANDER",
    "VARIAS",
  ];
  const tiposNegociacion = [
    "CONTADO",
    "CRÉDITO 15 DÍAS",
    "CRÉDITO 30 DÍAS",
    "CRÉDITO 60 DÍAS",
    "OTRO",
  ];

  /* Unused in original but kept for compatibility if passed down invisibly */
  const tiposNegociacion2 = [
    "ABASTECIMIENTO",
    "FABRICACIÓN",
    "GASTO",
    "LOGÍSTICA",
    "ORDEN DE VENTA",
    "SERVICIO TÉCNICO",
  ];


  const [tipoPersona, setTipoPersona] = useState('natural');
  const [solicitante, setSolicitante] = useState('');
  const [proceso, setProceso] = useState('ADMINISTRATIVO Y GESTION HUMANA');
  const [sucursal, setSucursal] = useState('ANTIOQUIA');
  const [servicio, setServicio] = useState('');
  const [tipoNegociacion, setTipoNegociacion] = useState('CONTADO');
  const [tipoNegociacion2, setTipoNegociacion2] = useState('ABASTECIMIENTO');
  const [nombreDiligenciaFormato, setNombreDiligenciaFormato] = useState('');
  const [cargoDiligenciaFormato, setCargoDiligenciaFormato] = useState('');
  const [tipoVinculacion, setTipoVinculacion] = useState('');

  const tipoVinculacionValues = [
    "Vinculación",
    "Actualización",
  ];


  const handleTipoPersonaChange = (event) => {
    setTipoPersona(event.target.value);
  };
  // Unused handlers kept
  const handleSolicitanteChange = (event) => setSolicitante(event.target.value);
  const handleProcesoChange = (event) => setProceso(event.target.value);

  const handleSucursalChange = (event) => {
    setSucursal(event.target.value);
  };

  const handleServicioChange = (event) => {
    const value = event.target.value;
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      setServicio(event.target.value);
    }
  };

  const handleTipoNegociacionChange = (event) => {
    setTipoNegociacion(event.target.value);
  };

  const handleTipoNegociacionChange2 = (event) => {
    setTipoNegociacion2(event.target.value);
  };

  const handCargoDiligenciaFormato = (event) => {
    setCargoDiligenciaFormato(event.target.value);
  };

  const HandMombreDiligenciaFormato = (event) => {
    setNombreDiligenciaFormato(event.target.value);
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ minHeight: '100vh', py: 4, display: 'flex', justifyContent: 'center' }}>
        <Container maxWidth="lg">
          <Card>
            <CardMedia
              component="img"
              sx={{ width: '100%', height: { xs: 200, sm: 300, md: 400 }, objectFit: 'cover' }}
              image={comoserproveedor}
              alt="Cómo ser proveedor Talsa"
            />

            <CardContent sx={{ p: { xs: 3, md: 5 } }}>
              <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Typography gutterBottom variant="h5" component="div">
                  Registro de Proveedores Nacionales
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Por favor complete la información inicial para continuar con el proceso.
                </Typography>
              </Box>

              <Box component="div" noValidate autoComplete="off">

                {/* Sección Tipo Persona */}
                <Box sx={{ mb: 4, p: 3, bgcolor: '#FFF', borderRadius: 3, border: '1px solid #F0F0F0' }}>
                  <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Person fontSize="small" sx={{ color: '#BD1F34' }} /> Tipo de Persona
                  </Typography>
                  <FormControl fullWidth variant="outlined" sx={{ mb: 3 }}>
                    <InputLabel id="tipo-persona-label">Seleccione el tipo</InputLabel>
                    <Select
                      labelId="tipo-persona-label"
                      id="tipo-persona"
                      value={tipoPersona}
                      onChange={handleTipoPersonaChange}
                      label="Seleccione el tipo"
                    >
                      <MenuItem value="natural">Persona Natural</MenuItem>
                      <MenuItem value="juridica">Persona Jurídica</MenuItem>
                    </Select>
                  </FormControl>

                  <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Work fontSize="small" sx={{ color: '#BD1F34' }} /> Tipo de Solicitud
                  </Typography>
                  <FormControl fullWidth variant="outlined">
                    <InputLabel id="tipo-vinculacion-label">Seleccione el tipo de solicitud</InputLabel>
                    <Select
                      labelId="tipo-vinculacion-label"
                      required
                      value={tipoVinculacion}
                      onChange={(e) => setTipoVinculacion(e.target.value)}
                      label="Seleccione el tipo de solicitud"
                    >
                      {tipoVinculacionValues.map((tipo) => (
                        <MenuItem key={tipo} value={tipo}>
                          {tipo}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>

                {/* Grid de Campos Generales */}
                <Typography variant="h6" gutterBottom sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <AssignmentInd fontSize="small" sx={{ color: '#BD1F34' }} /> Información General
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Nombre de quien diligencia"
                      value={nombreDiligenciaFormato}
                      onChange={HandMombreDiligenciaFormato}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Cargo"
                      value={cargoDiligenciaFormato}
                      onChange={handCargoDiligenciaFormato}
                      variant="outlined"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Sucursal / Departamento</InputLabel>
                      <Select
                        label="Sucursal / Departamento"
                        value={sucursal}
                        onChange={handleSucursalChange}
                      >
                        {sucursales.map((sucursal) => (
                          <MenuItem key={sucursal} value={sucursal}>
                            {sucursal}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Servicio a prestar"
                      value={servicio}
                      onChange={handleServicioChange}
                      variant="outlined"
                      helperText="Solo letras"
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel>Condiciones de pago</InputLabel>
                      <Select
                        label="Condiciones de pago"
                        value={tipoNegociacion}
                        onChange={handleTipoNegociacionChange}
                      >
                        {tiposNegociacion.map((tipo) => (
                          <MenuItem key={tipo} value={tipo}>
                            {tipo}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>

                {/* Renderizado Condicional del Formulario Específico */}
                <Box sx={{ mt: 5 }}>
                  {nombreDiligenciaFormato !== "" && cargoDiligenciaFormato !== "" && servicio !== "" ? (
                    tipoPersona === 'natural' ? (
                      <PersonaNatural
                        solicitanteValue={solicitante}
                        procesoValue={proceso}
                        sucursalValue={sucursal}
                        servicioValue={servicio}
                        tipoNegociacionValue={tipoNegociacion}
                        tipoNegociacion2Value={tipoNegociacion2}
                        idregisto={nitRegistro}
                        nombreFormato={nombreDiligenciaFormato}
                        cargoFormato={cargoDiligenciaFormato}
                        tipoPersonaRegistro={tipoPersona}
                        tipoVinculacionRegistro={tipoVinculacion}
                      />
                    ) : (
                      <PersonaJuridica
                        solicitanteValue={solicitante}
                        procesoValue={proceso}
                        sucursalValue={sucursal}
                        servicioValue={servicio}
                        tipoNegociacionValue={tipoNegociacion}
                        tipoNegociacion2Value={tipoNegociacion2}
                        idregisto={nitRegistro}
                        nombreFormato={nombreDiligenciaFormato}
                        cargoFormato={cargoDiligenciaFormato}
                        tipoPersonaRegistro={tipoPersona}
                        tipoVinculacionRegistro={tipoVinculacion}
                      />
                    )
                  ) : (
                    <Box sx={{ p: 4, textAlign: 'center', bgcolor: '#f8f8f8', borderRadius: 2, border: '1px dashed #ccc' }}>
                      <Typography variant="body1" color="text.secondary">
                        Por favor complete todos los campos de información general para desplegar el formulario detallado.
                      </Typography>
                    </Box>
                  )}
                </Box>

              </Box>
            </CardContent>
            <CardActions sx={{ justifyContent: 'center', pb: 3 }}>
              <Button size="small" color="secondary">Terminos y condiciones</Button>
            </CardActions>
          </Card>
        </Container>
      </Box>
    </ThemeProvider>
  );
};
